module.exports = __webpack_public_path__ + "media/cases-brand-chinamobile-lazyload-131.bb62df30.mp4";